import { PORTAL_GUEST_LIMITS, capPortalGuests } from "./guestRules";

export const PACKAGE_GUEST_LIMITS = PORTAL_GUEST_LIMITS;

const wholeNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? Math.floor(parsed) : fallback;
};

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export const normalizePackageGuests = (value = {}, limits = {}) => {
  const maxGuests = capPortalGuests(limits.maxGuests);
  const minAdults = clamp(
    wholeNumber(limits.minAdults, PACKAGE_GUEST_LIMITS.minAdults),
    1,
    maxGuests,
  );
  const maxAdults = clamp(
    wholeNumber(limits.maxAdults, PACKAGE_GUEST_LIMITS.maxAdults),
    minAdults,
    maxGuests,
  );
  const maxChildren = clamp(
    wholeNumber(limits.maxChildren, PACKAGE_GUEST_LIMITS.maxChildren),
    0,
    maxGuests - minAdults,
  );
  const maxInfants = clamp(
    wholeNumber(limits.maxInfants, PACKAGE_GUEST_LIMITS.maxInfants),
    0,
    maxGuests - minAdults,
  );
  const adults = clamp(
    wholeNumber(value?.adults ?? value?.adult ?? value?.adultCount, 2),
    minAdults,
    maxAdults,
  );
  const children = clamp(
    wholeNumber(value?.children ?? value?.child ?? value?.childCount, 0),
    0,
    Math.min(maxChildren, maxGuests - adults),
  );
  const infants = clamp(
    wholeNumber(value?.infants ?? value?.infant ?? value?.infantCount, 0),
    0,
    Math.min(maxInfants, maxGuests - adults - children),
  );
  return { adults, children, infants };
};

export const getPackageGuestCapacity = (value = {}, limits = {}) => {
  const normalized = normalizePackageGuests(value, limits);
  const maxGuests = capPortalGuests(limits.maxGuests);
  return {
    guests: normalized,
    total: normalized.adults + normalized.children + normalized.infants,
    remaining: Math.max(0, maxGuests - normalized.adults - normalized.children - normalized.infants),
    payingGuests: normalized.adults + normalized.children,
  };
};
